export default __webpack_public_path__ + "static/media/Multi-tenancy management.fffec983.png";